// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-3eeeebf7]{height:calc(100% - 260px)}.colorStyle[data-v-3eeeebf7]{color:red}.mdTitName[data-v-3eeeebf7]{height:24px;border:1px solid #d7d7d7;text-align:center;min-width:100px}", ""]);
// Exports
module.exports = exports;
